import template from './idle.template.html';

export default {
  controller: class controller {
    constructor($rootScope, $timeout, $state, $mdDialog, logger) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        $rootScope.$on('IdleStart', function () {
          logger.log('idleComponent', 'IdleStart', 'User has gone idle');
          $mdDialog.show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            controller: function ($rootScope, $timeout) {
              'ngInject';
              this.countdown = 60;
              this.countdownPercentage = 100;
              var self = this;
              $rootScope.$on('IdleWarn', function (e, countdown) {
                logger.debug(
                  'idleComponent',
                  'IdleWarn',
                  'Idle timeout in',
                  countdown,
                  'seconds'
                );
                $timeout(function () {
                  self.countdown = countdown;
                  self.countdownPercentage = (countdown / 60) * 100;
                });
              });
            }
          });
        });

        $rootScope.$on('IdleTimeout', function () {
          logger.log('idleComponent', 'IdleTimeout', 'User timed out');
          $mdDialog.cancel();
          $state.transitionTo('authenticate');
        });

        $rootScope.$on('IdleEnd', function () {
          logger.log('idleComponent', 'IdleEnd', 'User came back');
          $mdDialog.cancel();
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {};
    }
  }
};
